import { render, staticRenderFns } from "./TagAutocompleteMultiple.vue?vue&type=template&id=058a3f9c"
import script from "./TagAutocompleteMultiple.vue?vue&type=script&lang=js"
export * from "./TagAutocompleteMultiple.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports